import React, { useEffect, useState, useCallback } from "react";

const API = "https://vms.hexagons.tech/api";

export default function Users() {
  const [users, setUsers] = useState([]);

  const [form, setForm] = useState({
    username: "",
    password: "",
    role: "reception"
  });

  const token = localStorage.getItem("token");

  // ============================
  // FETCH USERS
  // ============================
  const fetchUsers = useCallback(async () => {
    try {
      const res = await fetch(`${API}/users`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = await res.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  }, [token]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // ============================
  // CREAR USUARIO
  // ============================
  const handleCreate = async (e) => {
    e.preventDefault();

    if (!form.username || !form.password) {
      alert("Complete los campos");
      return;
    }

    try {
      await fetch(`${API}/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(form)
      });

      setForm({
        username: "",
        password: "",
        role: "reception"
      });

      fetchUsers();
    } catch (err) {
      console.error(err);
    }
  };

  // ============================
  // ELIMINAR
  // ============================
  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar usuario?")) return;

    try {
      await fetch(`${API}/users/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      fetchUsers();
    } catch (err) {
      console.error(err);
    }
  };

  // ============================
  // RESET PASSWORD
  // ============================
  const handleResetPassword = async (id) => {
    const newPassword = prompt("Nueva contraseña:");
    if (!newPassword) return;

    try {
      await fetch(`${API}/users/${id}/reset-password`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ password: newPassword })
      });

      alert("Contraseña actualizada");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-4 md:p-6 space-y-6 bg-background min-h-screen">

      {/* HEADER */}
      <div>
        <h1 className="text-2xl font-bold text-primary">
          Gestión de Usuarios
        </h1>
        <p className="text-gray-500 text-sm">
          Administración de accesos del sistema
        </p>
      </div>

      {/* FORM */}
      <div className="bg-white p-6 rounded-2xl shadow border-l-4 border-primary">
        <h3 className="font-semibold text-primary mb-4">
          Crear usuario
        </h3>

        <form onSubmit={handleCreate} className="grid md:grid-cols-3 gap-3">

          <input
            placeholder="Usuario"
            className="border p-3 rounded-lg"
            value={form.username}
            onChange={(e) =>
              setForm({ ...form, username: e.target.value })
            }
          />

          <input
            type="password"
            placeholder="Contraseña"
            className="border p-3 rounded-lg"
            value={form.password}
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
          />

          <select
            className="border p-3 rounded-lg"
            value={form.role}
            onChange={(e) =>
              setForm({ ...form, role: e.target.value })
            }
          >
            <option value="reception">Recepción</option>
            <option value="admin">Administración</option>
            <option value="superadmin">Super Admin</option>
          </select>

          <button className="bg-primary text-white py-3 rounded-lg col-span-full">
            Crear usuario
          </button>

        </form>
      </div>

      {/* TABLE */}
      <div className="bg-white p-6 rounded-2xl shadow border-l-4 border-secondary">
        <h3 className="font-semibold text-primary mb-4">
          Usuarios registrados
        </h3>

        <div className="overflow-x-auto">

          <table className="min-w-full text-sm">

            <thead className="bg-secondary text-white">
              <tr>
                <th className="p-3 text-left">Usuario</th>
                <th className="p-3 text-left">Rol</th>
                <th className="p-3 text-left">Acciones</th>
              </tr>
            </thead>

            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center p-4 text-gray-500">
                    No hay usuarios
                  </td>
                </tr>
              ) : (
                users.map((u) => (
                  <tr key={u._id} className="border-t hover:bg-gray-50">

                    <td className="p-3">{u.username}</td>
                    <td className="p-3 capitalize">{u.role}</td>

                    <td className="p-3 flex gap-2">

                      <button
                        onClick={() => handleResetPassword(u._id)}
                        className="bg-accent text-white px-3 py-1 rounded"
                      >
                        Reset
                      </button>

                      <button
                        onClick={() => handleDelete(u._id)}
                        className="bg-red-500 text-white px-3 py-1 rounded"
                      >
                        Eliminar
                      </button>

                    </td>

                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>
      </div>

    </div>
  );
}